var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPasskeysRound = function SvgPasskeysRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#passkeys-round_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3AFBE",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.155 5.372 8.845 7.31a.207.207 0 0 0-.075.28l3.569 6.268H5.2a.2.2 0 0 0-.142.06.2.2 0 0 0-.059.144v3.876c0 .112.09.203.202.203h7.138L13.56 16l1.22-2.142L16 11.717l-3.569-6.27a.2.2 0 0 0-.275-.075m7.501 12.77H12.34l-3.57 6.269a.207.207 0 0 0 .075.28l3.31 1.938c.097.057.22.022.275-.076L16 20.285l3.568 6.268a.2.2 0 0 0 .275.075l3.31-1.938a.206.206 0 0 0 .075-.28l-3.568-6.268zm.002-4.284 3.569-6.268a.207.207 0 0 0-.075-.28l-3.308-1.938a.2.2 0 0 0-.276.075L16 11.715l1.22 2.141 1.22 2.142 1.22 2.141h7.139a.2.2 0 0 0 .201-.203V14.06a.21.21 0 0 0-.125-.188.2.2 0 0 0-.077-.016H19.66h.001z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "passkeys-round_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export { SvgPasskeysRound as ReactComponent };